import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Grid,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useParams } from "react-router-dom";
import {
  useGetBureauQuery,
  useUpdateBureauMutation,
} from "../../app/services/bureauApi";

function EditBureau() {
  const { id } = useParams();

  const { data: bureau, isLoading, isError } = useGetBureauQuery(id);
  const [updateBureau, { isLoading: isUpdating }] = useUpdateBureauMutation();

  const [formData, setFormData] = useState({
    nom: "",
    telephone: "",
    email: "",
    adresse: "",
    quartier: "",
    location: "",
    heure_ouverture: "",
    heure_fermeture: "",
    description: "",
  });
  const [image, setImage] = useState(null);
  const [alert, setAlert] = useState({ open: false, type: "", message: "" });
  const [openConfirm, setOpenConfirm] = useState(false);

  useEffect(() => {
    if (bureau) {
      setFormData({
        nom: bureau.nom || "",
        telephone: bureau.telephone || "",
        email: bureau.email || "",
        adresse: bureau.adresse || "",
        quartier: bureau.quartier || "",
        location: bureau.location || "",
        heure_ouverture: bureau.heure_ouverture || "",
        heure_fermeture: bureau.heure_fermeture || "",
        description: bureau.description || "",
      });
    }
  }, [bureau]);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenConfirm = (e) => {
    e.preventDefault();
    setOpenConfirm(true);
  };

  const handleConfirmUpdate = async () => {
    setOpenConfirm(false);

    let dataToSend = formData;

    if (image) {
      // Crée un FormData si image sélectionnée
      const form = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        form.append(key, value);
      });
      form.append("image", image);
      dataToSend = form;
    }

    try {
      const response = await updateBureau({ id, bureau: dataToSend }).unwrap();

      setAlert({
        open: true,
        type: "success",
        message: "Bureau mis à jour avec succès",
      });
      // Optionnel: rediriger après succès
      // setTimeout(() => navigate('/admin/bureaux'), 1500);
    } catch (error) {
      console.error("Erreur lors de la mise à jour :", error);
      setAlert({
        open: true,
        type: "error",
        message:
          error?.data?.message || "Erreur lors de la mise à jour du bureau",
      });
    }
  };

  if (isLoading) return <CircularProgress />;
  if (isError) return <Alert severity="error">Erreur lors du chargement</Alert>;

  return (
    <Container maxWidth="md" sx={{ backgroundColor: "#f9fbe7", p: 4, borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom>
        Modifier un bureau de change
      </Typography>

      {alert.open && (
        <Alert severity={alert.type} sx={{ mb: 2 }}>
          {alert.message}
        </Alert>
      )}

      <form onSubmit={handleOpenConfirm}>
        <Grid container spacing={2}>
          {[
            { name: "nom", label: "Nom" },
            { name: "telephone", label: "Téléphone" },
            { name: "email", label: "Email" },
            { name: "adresse", label: "Adresse" },
            { name: "location", label: "Lien Maps (iframe ou URL)" },
            { name: "quartier", label: "Quartier" },
            { name: "heure_ouverture", label: "Heure ouverture", type: "time" },
            { name: "heure_fermeture", label: "Heure fermeture", type: "time" },
            { name: "description", label: "Description" },
          ].map(({ name, label, type = "text" }) => (
            <Grid item xs={12} sm={6} key={name}>
              <TextField
                fullWidth
                label={label}
                name={name}
                type={type}
                value={formData[name]}
                onChange={handleChange}
              />
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button variant="contained" component="label">
              Choisir une image
              <input type="file" hidden accept="image/*" onChange={handleImageChange} />
            </Button>
            {image && <Typography mt={1}>{image.name}</Typography>}
          </Grid>

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isUpdating}
            >
              {isUpdating ? "Mise à jour..." : "Enregistrer les modifications"}
            </Button>
          </Grid>
        </Grid>
      </form>

      <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
        <DialogTitle>Confirmer la mise à jour</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Êtes-vous sûr de vouloir enregistrer les modifications apportées à ce bureau ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirm(false)} color="secondary">
            Annuler
          </Button>
          <Button onClick={handleConfirmUpdate} color="primary" autoFocus>
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default EditBureau;
